import type { Components, Theme } from '@mui/material/styles';
import { data } from './overrides/data';
import { inputs } from './overrides/inputs';
import { surfaces } from './overrides/surfaces';

export const components: Components<Theme> = { ...surfaces, ...inputs, ...data };
